var swiper = new Swiper(".image-with-text-slider-wrapper", {
  grabCursor: true,
  speed: 500,
  effect: "slide",
  loop: true,
  autoHeight: true,
  mousewheel: {
    invert: false,
    sensitivity: 1,
  },
});

$(".faqs-title-and-icon").click(function () {
  if ($(this).next().length != 0) {
    $(this).next().slideToggle();
    $(this).parent(".faq-items").toggleClass("active");
  }
});

//  Image Faq Slider
var swiper = new Swiper(".image_faqs_slider", {
  paginationClickable: true,
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: true,
  loop: true,
  loopedSlides: 50,
  slidesPerView: "auto",
  coverflowEffect: {
    rotate: -1,
    stretch: 200,
    depth: 400,
    modifier: 1,
    slideShadows: true
  },
  spaceBetween: 0,
});


// PC CUSTOM SLIDER -DM- J

var swiperMain = new Swiper(".pc-custom_slider", {
  slidesPerView: 2,
  slidesPerColumn: 1,
  loopedSlides: 50,
  loop: true,
  draggable: true,
  autoplay: false,
  spaceBetween: 20,
});

var swiperAsNav = new Swiper(".gallery-thumb", {
  slidesPerView: 1,
  slidesPerColumn: 1,
  loopedSlides: 50,
  loop: true,
  draggable: true,
  autoplay: false,
});

swiperMain.on("slideChange", function () {
  var swiperMainRealIndex = swiperMain.activeIndex;
  swiperAsNav.slideTo(swiperMainRealIndex);
});

swiperAsNav.on("slideChange", function (){
  var swiperIndex = swiperAsNav.activeIndex;
  console.log(swiperAsNav, "swiperAsNav");
  swiperMain.slideTo(swiperIndex);
});

// swiperAsNav.on('slideChange', function () {
// var swiperAsNavRealIndex = swiperAsNav.activeIndex;
//     swiperMain.slideTo(swiperAsNavRealIndex);
// });

var redButtons = document.querySelectorAll('.red_btn:not(.b2b_contact__button)');

redButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
        var element = document.querySelector(".section_pc_contact_form_main");

        element.scrollIntoView({behavior: "smooth"});
    });
});